import { useContext } from "react"
import { LeadContext } from "./lead.context";


export const useLead = () => {
    const  context = useContext(LeadContext)
    if (context === undefined){
        throw new Error(`Component is not inside LeadContext scope`);
    }
    return context
}